import { jsonMember, jsonObject } from 'typedjson';

@jsonObject
export class AdminCartSettingsUpdateRequest {
  @jsonMember(Boolean)
  public readonly deleteCartAfterCheckout!: boolean;

  public constructor(
    private readonly data: {
      deleteCartAfterCheckout: boolean;
    },
  ) {
    this.deleteCartAfterCheckout = this.data.deleteCartAfterCheckout;
  }
}
